import React, { useEffect, useState } from "react";
import Auth from "@aws-amplify/auth";
// import CardInfo from "../../components/Cards/CardInfo/CardInfo";
import classes from "./ButtonGoPremium.module.scss";
import ButtonGoPremium from "../../components/Buttons/ButtonGoPremium/ButtonGoPremium";
import { useTranslation } from "react-i18next";
import H1 from "../../components/UI/Titles/H1/h1";
import H2 from "../../components/UI/Titles/H2";
import afinandoFlying from "../../assets/images/achievements/user_level_4.svg";
// import { useSelector } from "react-redux";
// import { PROBRAIN_LINK } from "../../constants/api";

const GoPremium = ({
  title,
  info,
  image
}) => {
  const { t } = useTranslation();
  const [token, setToken] = useState(null);
  useEffect(() => {
    if(!token) {
      setToken(Auth.currentSession().then((data) => {
        return data.getAccessToken().getJwtToken();
      }));
    }
    
  }, [token]);

  return (
    <div className={classes.mainCard+" "+ classes.mb20}>
      <div className=" row" >
        <div className="col-12 col-sm-3">
          <img  
            alt="" 
            src={image == null ? afinandoFlying : image}
            className={image ? classes.goPremiumGif : classes.goPremiumImage + " " + classes.floating}
          />
        </div>
        <div className="col-12 col-sm-9" style={{ marginTop: "20px"}}>
          <H1>{t(title)}</H1>
          <span style={{ marginTop: "15px" }}>
            <H2>
              {t(info)}
            </H2>
          </span>
          <div className={image ? classes.buttonGo : ''} style={{ marginTop: "25px" }}>
            <ButtonGoPremium
              text= {t("global.signPremium")}
              token={token}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoPremium;
